// Barrel export for the home page content layer.
// Every home section reads its content from here, so copy can be edited
// in the JSON files without touching component code.
export { default as heroData } from "./hero.json";
export { default as statsData } from "./stats.json";
export { default as aboutData } from "./about.json";
export { default as whyNcetData } from "./whyNcet.json";
export { default as anniversaryData } from "./anniversary.json";
export { default as accreditationsData } from "./accreditations.json";
export { default as studyData } from "./study.json";
export { default as careersData } from "./careers.json";
export { default as campusLifeData } from "./campusLife.json";
export { default as companiesData } from "./companies.json";
export { default as notificationsData } from "./notifications.json";
export { default as ctaData } from "./cta.json";
export { default as toriiMindsData } from "./toriiMinds.json";
export { default as knownForData } from "./knownFor.json";
